<template>
    <span>
        <i v-if="admin" class="fas fa-cog nav-icon cog-button" @click.prevent.stop="toggle_form()"></i>
          {{ config_value }}

          <div v-if="admin && form_visible" class="text-popover">
            <div class="form-group">
                <input class="form-control" @click.prevent.stop="" v-model="new_config_value" type="text">
            </div>
            <button type="button" class="btn btn-success" @click.prevent.stop="post_form()">Valider</button>
              <button class="btn btn-secondary" type="button" @click="toggle_form()">Annuler</button>
          </div>

    </span>
</template>

<script>

export default {
  props: {
    config: String,
    default: String
  },
  data: function () {
    return {
      form_visible: false,
      config_value: '',
      new_config_value: '',
      admin: 0,
    }
  },

  mounted() {
    this.config_value = this.default
    this.get_data()
  },

  methods: {

    toggle_form: function () {
      this.form_visible = !this.form_visible;
    },

    get_data: function () {
      let _this = this
      get_token_2().then(function (response) {
        let [secure_key, customer_id, api_url, customer, admin] = response

        _this.admin = admin

        api_url += "configs/get_value.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id
        api_url += '&key=' + _this.config

        axios.get(api_url)
            .then(function (response) {
              const config_exists = response.data.meta.exists
              if (config_exists) {
                if (response.data.config_value != null)
                  _this.config_value = response.data.config_value
              }
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      })
    },

    post_form: function () {
      let _this = this
      get_token_2().then(function (response) {
        let [secure_key, customer_id, api_url, customer] = response
        api_url += "configs.json"
        api_url += '?secure_key=' + secure_key
         api_url += '&customer_id=' + customer_id

        const form_data = new FormData();
        form_data.append('id', _this.config)
        form_data.append('config[name]', _this.config)
        form_data.append('config[value]', _this.new_config_value)

        axios({
          method: 'post',
          url: api_url,
          data: form_data
        })
            .then(function (response) {
              _this.toggle_form()
              _this.get_data()
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      })
    },

  }

}
</script>

<style scoped>
.cog-button {
}

.text-popover {
  width: 320px;
  position: fixed;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, .25);
  box-shadow: 0 3px 10px rgba(0, 0, 0, .25);
  z-index: 9999;
  background-color: #fff;
  padding: 1rem;
}
</style>